import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box } from "@ui/box/Box";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import { useState } from "react";
import { GD } from "src/GD";
import { FormParser } from "../FormParser";
import { getNotificationErrorMessage, notify } from "../../tools/notify";
import { mergeObject } from "src/utils/tools";

export const S_REGISTER_PAYSWIX_CLIENT_POPUP = new Signal<{ onSuccess?: () => void } | null>("S_REGISTER_PAYSWIX_CLIENT_POPUP");

const decorator = {
	company_registration_address: {
		$__country_type: "country",
	},

	company_business_place: {
		$__country_type: "country",
	},
};

export const RegisterPayswixClientPopup = () => {
	useLocale();
	const requestData = S_REGISTER_PAYSWIX_CLIENT_POPUP.use();
	const [project] = GD.B_SELECTED_PROJECT.use();

	const [busy, setBusy] = useState(false);

	const closePopup = () => {
		S_REGISTER_PAYSWIX_CLIENT_POPUP.invoke(null);
		setBusy(false);
	};

	if (!requestData) return null;

	return (
		<Panel
			sx={{ minWidth: "600px", maxWidth: "800px", width: "99vw", minHeight: "85vh", maxHeight: "95vh" }}
			decorator="absolute"
			label={msg("templateRegisterClient_fa79e53e", { v0: project?.name ?? "Payswix" })}
			onClose={closePopup}
			busy={busy}>
			<Box sx={{ height: "100%", overflow: "auto" }}>
				<FormParser
					onRequest={async () => {
						const res = await GD.REQ_API.request({
							method: "clients/payswix/get",
						});
						if (res?.error) {
							return res;
						}
						if (!res?.data?.data) {
							return { error: { code: -1, message: msg("clientRegistrationFormCouldNotBeLoaded") } };
						}
						mergeObject(res.data.data, decorator);

						//	return JSON.parse(JSON.stringify(payswixClientModel));
						return res;
					}}
					onSubmit={async (data: unknown) => {
						setBusy(true);
						try {
							const res = await GD.REQ_API.request({
								method: "clients/payswix/set",
								data: data,
							});
							if (res?.error) {
								return res;
							}
							if (!res?.data) {
								return { error: { code: -1, message: msg("clientRegistrationReturnedAnEmptyResponse") } };
							}
							notify.success(msg("clientRegisteredSuccessfully"), { autoClose: 3000 });
							closePopup();
							requestData.onSuccess?.();
							return res;
						} catch (error) {
							const message = getNotificationErrorMessage(error, msg("clientCouldNotBeRegistered"));
							return { error: { code: -1, message } };
						} finally {
							setBusy(false);
						}
					}}
				/>
			</Box>
		</Panel>
	);
};
